{
  "$schema": "https://mux.run/theme.json",
  "name": "Flexoki",
  "id": "flexoki",
  "light": {
    "palette": {
      "neutral": "#FFFCF0",
      "ink": "#100F0F",
      "primary": "#205EA6",
      "accent": "#BC5215",
      "success": "#66800B",
      "warning": "#BC5215",
      "error": "#AF3029",
      "info": "#24837B"
    },
    "overrides": {
      "text-weak": "#6F6E69",
      "syntax-comment": "#6F6E69",
      "syntax-keyword": "#66800B",
      "syntax-string": "#24837B",
      "syntax-primitive": "#BC5215",
      "syntax-variable": "#205EA6",
      "syntax-property": "#24837B",
      "syntax-type": "#AD8301",
      "syntax-constant": "#5E409D",
      "syntax-operator": "#6F6E69",
      "syntax-punctuation": "#6F6E69",
      "syntax-object": "#205EA6",
      "markdown-heading": "#5E409D",
      "markdown-text": "#100F0F",
      "markdown-link": "#205EA6",
      "markdown-link-text": "#24837B",
      "markdown-code": "#24837B",
      "markdown-block-quote": "#AD8301",
      "markdown-emph": "#AD8301",
      "markdown-strong": "#BC5215",
      "markdown-horizontal-rule": "#6F6E69",
      "markdown-list-item": "#BC5215",
      "markdown-list-enumeration": "#24837B",
      "markdown-image": "#A02F6F",
      "markdown-image-text": "#24837B",
      "markdown-code-block": "#100F0F"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#100F0F",
      "ink": "#CECDC3",
      "primary": "#DA702C",
      "accent": "#8B7EC8",
      "success": "#879A39",
      "warning": "#DA702C",
      "error": "#D14D41",
      "info": "#3AA99F",
      "interactive": "#4385BE"
    },
    "overrides": {
      "text-weak": "#6F6E69",
      "syntax-comment": "#6F6E69",
      "syntax-keyword": "#879A39",
      "syntax-string": "#3AA99F",
      "syntax-primitive": "#DA702C",
      "syntax-variable": "#4385BE",
      "syntax-property": "#3AA99F",
      "syntax-type": "#D0A215",
      "syntax-constant": "#8B7EC8",
      "syntax-operator": "#B7B5AC",
      "syntax-punctuation": "#B7B5AC",
      "syntax-object": "#4385BE",
      "markdown-heading": "#8B7EC8",
      "markdown-text": "#CECDC3",
      "markdown-link": "#4385BE",
      "markdown-link-text": "#3AA99F",
      "markdown-code": "#3AA99F",
      "markdown-block-quote": "#D0A215",
      "markdown-emph": "#D0A215",
      "markdown-strong": "#DA702C",
      "markdown-horizontal-rule": "#6F6E69",
      "markdown-list-item": "#DA702C",
      "markdown-list-enumeration": "#3AA99F",
      "markdown-image": "#CE5D97",
      "markdown-image-text": "#3AA99F",
      "markdown-code-block": "#CECDC3"
    }
  }
}
